import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { __ } from '../../translations';
import { Lock as OriginalLock } from '@intigral/shared';
import { showUpgradedModal } from '../../store/reducers/generalConfigurationSlice';

//  FIXED: Create a wrapper for Lock to handle boolean relative prop
const Lock = (props) => {
    const { relative, ...otherProps } = props;
    const relativeString = relative === true ? 'true' : relative === false ? 'false' : relative;
    return <OriginalLock {...otherProps} relative={relativeString} />;
};

const LockIcon = (props) => {
    const dispatch = useDispatch();

    return (
        <Lock
            {...props}
            onClick={() => {
                if (!props.channel?.isPPV) {
                    dispatch(showUpgradedModal(true));
                }
            }}
        />
    );
};

export default LockIcon;
